import { TEAMS_SESSION_ID } from '@/shared/lib/constants';
import { useState, useEffect } from 'react';

const useIsTeams = () => {
  const [isTeams, setIsTeams] = useState(false);

  useEffect(() => {
    const sessionValue = window.sessionStorage.getItem(TEAMS_SESSION_ID);
    setIsTeams(sessionValue === 'true');
  }, []);

  return isTeams;
};

export default useIsTeams;
